export default str => {
  if (typeof str !== 'string' || !str) {
    return false;
  }
  return str.match('=');
};
